<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-claim-list" class="ag-grid-container">
    <statistics-cards :data="statisticalData"/>

    <div class="vx-card">
      <grid-panel
          height="md"
          :column-defs="columnDefs"
          :url="() => this.commercialClaimList"
          :auto-size="true"
          @rowClicked="view"
          class="commercial-claims-grid"
          @update:deleted="getCommercialClaims"
          ref="commercialClaimsGrid"
          title="Commercial Claims"
      >

        <vs-dropdown-item class="create-commercial-claim-action" v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: 'commercial-claims.create' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create Commercial Claim</span>
          </span>
        </vs-dropdown-item>

      </grid-panel>
    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import StatisticsCards from '@/components/statistics-cards/StatisticsCards.vue'
import CommercialClaimTransferModal from "@/views/pages/commercial-claims/CommercialClaimTransferModal";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import ButtonToggle from "../../components/extra-components/toggle/ButtonToggle";

export default {
  components: {
    TGrid,
    GridPanel,
    YesNoToggle,
    StatisticsCards,
    CommercialClaimTransferModal,
    ButtonToggle
  },
  mixins: [CellMatchingMixin, NotificationMixin, CanAccessMixin],
  data () {
    return {
      componentAccess: {
        canCreate: {
          route: 'commercial-claims.create',
          access: false,
        },
        canEdit: {
          route: 'commercial-claims.edit',
          access: false,
        },
      },
      toggleValue: 0,
      commercialClaimList: {},
      searchQuery: '',
      showDeleted: false,

      modals: {
        transferModal: {
          visible: false
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Commercial Claim',
          field: 'CommercialClaimNotificationName',
          filter: 'agTextColumnFilter',
          sort: 'asc',
        },
        {
          headerName: 'Risk Class',
          field: 'RiskCodeName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Sub Risk Class',
          field: 'SubRiskCodeName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Sales Country',
          field: 'salesCountryType',
          filter: 'agTextColumnFilter',
          minWidth: 170,
        },
      ],
      statisticalData: {
        commercialClaims: {
          icon: 'file-alt',
          label: 'Total Claims',
          value: 0,
          tooltipText: 'Claims',
        },
      },
    }
  },
  computed: {
    showGridOne() {
      return this.toggleValue === 0;
    },
  },
  watch: {
    commercialClaimList: {
      async handler(commercialClaims) {
        const { data } = await commercialClaims;
        let count = 0;

        if (data) {
          count = data.data.length;
        }

        this.statisticalData.commercialClaims.value = count;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getCommercialClaims(isDeleted = 0) {
      const params = { IsDeleted: isDeleted };
      this.commercialClaimList = this.$api.commercialClaims.list({ params });

      return this.commercialClaimList;
    },
    view({data}) {
      // Handle grouped rows
      if (!data) {
        return;
      }

      const id = data.CommercialClaim_PK || data.id;

      this.$router.push({
        name: 'commercial-claims.view',
        params: {id}
      }).catch(() => {
      });
    },
    modalError(errorMessage) {
      this.$vs.notify({
        color: 'danger',
        title: 'Error occurred',
        text: errorMessage,
        position: 'top-right'
      })
    },
  },
  created() {
    this.getCommercialClaims();
  },
}

</script>

<style lang="scss">
.create-commercial-claim-action {
  width: 215px;
}

.statistical-box {
  color: black;
  border: 1px solid black;
  padding: 10px;
  text-align: center;
  width: 120px;
  border-radius: 5px;

  .stat-number {
    font-weight: bold;
    font-size: 18px;
  }
}
</style>
